const toBuf = (s) => {
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((s.length + 3) % 4);
  return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0)).buffer;
};
const toB64url = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

export async function biometricAvailable() {
  try {
    return !!(window.PublicKeyCredential && await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable());
  } catch { return false; }
}

const parseCreate = (o) => (PublicKeyCredential.parseCreationOptionsFromJSON
  ? PublicKeyCredential.parseCreationOptionsFromJSON(o)
  : { ...o, challenge: toBuf(o.challenge), user: { ...o.user, id: toBuf(o.user.id) },
      excludeCredentials: (o.excludeCredentials || []).map((c) => ({ ...c, id: toBuf(c.id) })) });

const parseGet = (o) => (PublicKeyCredential.parseRequestOptionsFromJSON
  ? PublicKeyCredential.parseRequestOptionsFromJSON(o)
  : { ...o, challenge: toBuf(o.challenge), allowCredentials: (o.allowCredentials || []).map((c) => ({ ...c, id: toBuf(c.id) })) });

const credJSON = (c) => {
  if (c.toJSON) return c.toJSON();
  const r = c.response;
  const response = { clientDataJSON: toB64url(r.clientDataJSON) };
  if (r.attestationObject) response.attestationObject = toB64url(r.attestationObject);
  if (r.authenticatorData) response.authenticatorData = toB64url(r.authenticatorData);
  if (r.signature) response.signature = toB64url(r.signature);
  if (r.userHandle) response.userHandle = toB64url(r.userHandle);
  return { id: c.id, rawId: toB64url(c.rawId), type: c.type, response, clientExtensionResults: c.getClientExtensionResults?.() || {} };
};

export async function createPasskey(options) {
  const c = await navigator.credentials.create({ publicKey: parseCreate(options) });
  return credJSON(c);
}

export async function getPasskey(options) {
  const c = await navigator.credentials.get({ publicKey: parseGet(options) });
  return credJSON(c);
}
